import PropTypes from 'prop-types';
import React from 'react';
import { theme } from 'styled';
import { useTranslation } from 'react-i18next';
import {
    Actions,
    ActiveContainer,
    Avatar,
    ComponentContainer,
    Container,
    Icon,
    IconContainer,
    Info,
    Status,
    Text,
    Title
} from './styled';
import {
    Checkbox,
    MaterialIcon
} from 'mol-ui';
const { textColor } = theme;

const ListingItem = ({
    active,
    activeDisabled,
    allowDelete,
    allowEdit = true,
    allowView = true,
    avatar,
    color,
    hideAvatar,
    icon,
    iconColor,
    mandatory,
    mandatoryDisabled,
    onActionClick,
    onActiveChange,
    onMandatoryChange,
    reference,
    status,
    showActive,
    showMandatory,
    text,
    title,
    titleColor
}) => {

    const { t } = useTranslation();

    return (
        <Container>
            <Info>
                {
                    !hideAvatar &&
                    <Icon color={ color }>
                        {
                            avatar ?
                                <Avatar src={ avatar } /> :
                                <MaterialIcon color={ textColor } icon={ icon } size={ 35 } />
                        }
                    </Icon>
                }
                <div>
                    <Title color={ titleColor }>{ title }</Title>
                    <Text>{ text }</Text>
                    <Text>{ reference }</Text>
                    { status && <Status status={ status }>{ status }</Status> }
                </div>
            </Info>
            {
                onActionClick &&
                <Actions>
                    {
                        (showActive || showMandatory) &&
                        <ActiveContainer>
                            {
                                showActive &&
                                <ComponentContainer>
                                    <Checkbox
                                        checked={ active }
                                        disabled={ activeDisabled }
                                        label={ t('Habilitado') }
                                        onClick={ onActiveChange }
                                    />
                                </ComponentContainer>
                            }
                            {
                                showMandatory &&
                                <ComponentContainer>
                                    <Checkbox
                                        checked={ mandatory }
                                        disabled={ mandatoryDisabled }
                                        label={ t('Cambiar contraseña') }
                                        onClick={ onMandatoryChange }
                                    />
                                </ComponentContainer>
                            }
                        </ActiveContainer>
                    }
                    {
                        !!allowView &&
                        <IconContainer onClick={ () => onActionClick(t('ver')) }>
                            <MaterialIcon color={ iconColor ? iconColor : textColor } icon="remove_red_eye" size={ 25 } />
                        </IconContainer>
                    }
                    {
                        !!allowEdit &&
                        <IconContainer onClick={ () => onActionClick(t('editar')) }>
                            <MaterialIcon color={ iconColor ? iconColor : textColor } icon="edit" size={ 25 } />
                        </IconContainer>
                    }
                    {
                        !!allowDelete &&
                        <IconContainer onClick={ () => onActionClick(t('eliminar')) }>
                            <MaterialIcon color={ iconColor ? iconColor : textColor } icon="delete" size={ 25 } />
                        </IconContainer>
                    }
                </Actions>
            }
        </Container>
    );
};

ListingItem.propTypes = {
    active: PropTypes.bool,
    activeDisabled: PropTypes.bool,
    allowDelete: PropTypes.bool,
    allowEdit: PropTypes.bool,
    allowView: PropTypes.bool,
    avatar: PropTypes.string,
    color: PropTypes.string,
    hideAvatar: PropTypes.bool,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    mandatory: PropTypes.bool,
    mandatoryDisabled: PropTypes.bool,
    onActionClick: PropTypes.func,
    onActiveChange: PropTypes.func,
    onMandatoryChange: PropTypes.func,
    reference: PropTypes.string,
    showActive: PropTypes.bool,
    showMandatory: PropTypes.bool,
    status: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    titleColor: PropTypes.string
};

ListingItem.displayName = 'ListingItem';

export default ListingItem;
